import { createFileRoute } from '@tanstack/react-router'
import { FounderLayout } from '../../../../components/founder-layout'
import { WorkspaceReadyGuard } from '../../../../components/workspace-ready-guard'
import { OutreachOutcomesView } from '../../../../features/outreach/components/outreach-outcomes-view'

/**
 * What the founder was promised by the card that sent them here, so the page
 * can land on it rather than on the stat cards above it.
 *
 * `unread` — Home's "Reply now", the sidebar's count: the first unread reply.
 * `outcome` — "See what happened", "See the conversation": the confirmed call
 *   or intro, falling back to the reply behind it while it is still being
 *   verified and has no confirmed card yet.
 *
 * Absent on an ordinary visit, which stays where it lands.
 */
export type ReplyFocus = 'unread' | 'outcome'

export interface SearchParams {
  focus?: ReplyFocus
}

export const Route = createFileRoute('/app/startup/$id/outreach/replies')({
  component: OutreachRepliesPage,
  validateSearch: (search: Record<string, unknown>): SearchParams =>
    search.focus === 'unread' || search.focus === 'outcome' ? { focus: search.focus } : {},
})

function OutreachRepliesPage() {
  const { id: startupId } = Route.useParams()
  const { focus } = Route.useSearch()
  return (
    <WorkspaceReadyGuard>
      <FounderLayout activeNav="">
        <OutreachOutcomesView startupId={startupId} focus={focus} />
      </FounderLayout>
    </WorkspaceReadyGuard>
  )
}
